import { trigger, transition, state, style, animate } from '@angular/animations';

export const AAG_ANIMATIONS = [
    trigger('detailState', [
        state('*', style({
            opacity: 0,
            transform: 'translateX(50px)'
        })),
        state('loaded', style({
            opacity: 1,
            transform: 'translateX(0)'
        })),
        transition('* => loaded', animate('800ms ease-out'))
    ])
];
